/**
 * The hover of an override cell (components/grid/OverrideCellRenderer): the
 * system value, then the one gesture that applies — click to override it, or
 * clear to go back to it.
 *
 * @param {string} systemLabel  "<name>: <value>", formatted by the caller
 * @param {boolean} modified    whether a person's value is in force
 * @param {(key: string) => string} t
 * @param {{override: string, reset: string}} gestures  the two lines' keys.
 *   The reset line names what a clear goes back to, so every grid names its
 *   own.
 */
export function overrideCellTooltip(systemLabel, modified, t, gestures) {
  return `${systemLabel}\n${t(modified ? gestures.reset : gestures.override)}`;
}
